export default __webpack_public_path__ + "static/media/logo.dd427a1b.svg";